import styled from "styled-components";

import materialUI from "../../material-UI";

export const Text = styled(materialUI.Typography)``;
